import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    if (!props?.image?.baseUrl || !props?.labelUrl?.length) {
        return [
            "This Section Front Header Module requires both an uploaded image and a url to link it to.",
        ];
    }

    return [];
}
